// import axios from "axios";

// import { API_URL } from "../config/secrets";

// /**
//  * Request Wrapper with default success/error actions
//  */
// const request = async (options) => {
//   const token = window.localStorage.getItem("@getGeek/token");

//   const client = axios.create({
//     baseURL: API_URL,
//     // baseURL: "http://192.168.18.24:3002",
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
//   const onSuccess = (response) => {
//     return response?.data;
//   };

//   const onError = (error) => {
//     if (
//       error.response?.status === 401 &&
//       error.response?.statusText === "Unauthorized"
//     ) {
//       window.localStorage.removeItem("@getGeek/token");
//     } else {
//       // Something else happened while setting up the request
//       // triggered the error
//       // console.debug('Error Message:', error.message);
//     }

//     return Promise.reject(error.response ? error.response.data : error);
//   };

//   return client(options).then(onSuccess).catch(onError);
// };

// export default request;
import axios from "axios";

import { API_URL } from "../config/secrets";

/**
 * Request Wrapper with default success/error actions
 */
const request = async (options) => {
  const token = process.env.REACT_APP_USER_TOKEN;

  const client = axios.create({
    baseURL: API_URL,
    // baseURL: "http://192.168.18.24:3002",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const onSuccess = (response) => {
    return response?.data;
  };

  const onError = (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.statusText === "Unauthorized"
    ) {
      window.localStorage.removeItem("@getGeek/token");
    } else {
      // Something else happened while setting up the request
      // triggered the error
      // console.debug('Error Message:', error.message);
    }

    return Promise.reject(error.response ? error.response.data : error);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
